export default "__VITE_ASSET__6a46bf2f__"